class LandingsTable {

    constructor(AppWeb = null) {
        this.AppWeb = AppWeb;
    }

    bindLandingActiveChange(element) {
        $('.landingActiveChange').change(function(){
            let landing = $(this).attr('data-landing');
            let isCheched = $(this).prop('checked');
            $.ajax({
                url: '/web/activateLanding',
                data: {checked: isCheched, id: landing},
                dataType: "json",
                type: "post",
                success: function(data) {
                }
            });

        });
    }

    bindAll() {
       this.bindLandingActiveChange();
    }
}

module.exports = LandingsTable;


// WEBPACK FOOTER //
// ./devel/js/landing/landingsTable.js